import { render, staticRenderFns } from "./StepName.vue?vue&type=template&id=0b0a434a"
import script from "./StepName.vue?vue&type=script&lang=js"
export * from "./StepName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports